import { sBanner } from '../../shared.min.js';
import { sBannerStep } from '../../shared.min.js';

const priceIndexCalc = (() => {
	let jsonData;

	const calcHeading = document.getElementById('calculator-heading'),
		bannerCMSContainer = document.getElementById('pic-cms'),
		bannerStep1Text = bannerCMSContainer.getAttribute('data-banner-step-1-text'),
		bannerStep2Text = bannerCMSContainer.getAttribute('data-banner-step-2-text'),
		dataCMSContainer = document.getElementById('pic-cms-data'),
		errorRegion = dataCMSContainer.getAttribute('data-error-region'),
		errorAge = dataCMSContainer.getAttribute('data-error-age'),
		errorGender = dataCMSContainer.getAttribute('data-error-gender'),
		widget = document.getElementById('cnfsd-pic-widget');

	//screen 1
	const priceIndexForm = document.getElementById('cnfsd-pic-form'),
		selectRegion = document.getElementById('price-index-region'),
		selectAge = document.getElementById('price-index-age'),
		continueBtn = document.getElementById('price-index-continue');

	//screen 2
	const priceIndexResults = document.getElementById('price-index-results'),
		resetBtn = document.getElementById('reset'),
		premiumEl = document.getElementById('premium'),
		annChangeEl = document.getElementById('annChange'),
		resultsText = document.getElementById('results-text');

	const regionOptions = {
		east: 'East',
		leedssheffield: 'Leeds/Sheffield',
		londoninner: 'London-inner',
		londonouter: 'London-outer',
		manchestermerseyside: 'Manchester/Merseyside',
		midlandseast: 'Midlands-east',
		midlandsnorth: 'Midlands-north',
		midlandswest: 'Midlands-west',
		north: 'North',
		northeast: 'North-east',
		northwest: 'North-west',
		northernireland: 'Northern Ireland',
		scotlandborders: 'Scotland-borders',
		scotlandcentral: 'Scotland-central',
		scotlandeastnew: 'Scotland-eastnew',
		scotlandhighlandsislands: 'Scotland-highlandsislands',
		south: 'South',
		southcentral: 'South-central',
		southeast: 'South-east',
		southwest: 'South-west',
		walescentralnorth: 'Wales-Central & North',
		walessouth: 'Wales-south',
		west: 'West',
	};

	const ageOptions = {
		ageGroup1: '17-20',
		ageGroup2: '21-25',
		ageGroup3: '26-30',
		ageGroup4: '31-35',
		ageGroup5: '36-40',
		ageGroup6: '41-45',
		ageGroup7: '46-50',
		ageGroup8: '51-55',
		ageGroup9: '56-60',
		ageGroup10: '61-65',
		ageGroup11: '66-70',
		ageGroup12: '71 plus',
	};

	function populateDropdowns() {
		Object.entries(regionOptions).forEach(([code, name]) => {
			const option = document.createElement('option');
			option.value = code;
			option.textContent = name;
			selectRegion.appendChild(option);
		});

		Object.entries(ageOptions).forEach(([code, name]) => {
			const option = document.createElement('option');
			option.value = code;
			option.textContent = name;
			selectAge.appendChild(option);
		});
	}

	//Validation functions
	function validateRegion(errorRegion) {
		const regionValue = selectRegion.value;
		const regionText = selectRegion.options[selectRegion.selectedIndex].text;
		const regionErrorContainer = document.querySelector("[data-testid='error-region']");
		const regionErrorWrapper = regionErrorContainer?.closest('.field-validation-error');

		let hasError = false;

		if (!regionValue || regionValue === 'not-selected') {
			regionErrorContainer.textContent = errorRegion;
			regionErrorContainer.classList.remove('display-none');
			if (regionErrorWrapper) regionErrorWrapper.classList.add('show-error');
			hasError = true;
		} else {
			regionErrorContainer.textContent = '';
			regionErrorContainer.classList.add('display-none');
			if (regionErrorWrapper) regionErrorWrapper.classList.remove('show-error');
		}

		return {
			hasError,
			value: regionValue,
			text: regionText,
		};
	}

	function validateAge(errorAge) {
		const ageValue = selectAge.value;
		const ageText = selectAge.options[selectAge.selectedIndex].text;
		const ageErrorContainer = document.querySelector("[data-testid='error-age']");
		const ageErrorWrapper = ageErrorContainer?.closest('.field-validation-error');

		let hasError = false;

		if (!ageValue || ageValue === 'not-selected') {
			ageErrorContainer.textContent = errorAge;
			ageErrorContainer.classList.remove('display-none');
			if (ageErrorWrapper) ageErrorWrapper.classList.add('show-error');
			hasError = true;
		} else {
			ageErrorContainer.textContent = '';
			ageErrorContainer.classList.add('display-none');
			if (ageErrorWrapper) ageErrorWrapper.classList.remove('show-error');
		}

		return {
			hasError,
			value: ageValue,
			text: ageText,
		};
	}

	function validateGender(errorGender) {
		const genderEl = document.querySelector('input[name="gender"]:checked');
		const genderText = genderEl ? genderEl.labels[0].textContent : '';
		const genderErrorContainer = document.querySelector('[data-testid="error-gender-radio"]');
		const genderErrorWrapper = genderErrorContainer?.closest('.field-validation-error');

		let hasError = false;
		let genderValue = null;

		if (!genderEl) {
			genderErrorContainer.textContent = errorGender;
			genderErrorContainer.classList.remove('display-none');
			if (genderErrorWrapper) genderErrorWrapper.classList.add('show-error');
			hasError = true;
		} else {
			genderValue = genderEl.value;
			genderErrorContainer.textContent = '';
			genderErrorContainer.classList.add('display-none');
			if (genderErrorWrapper) genderErrorWrapper.classList.remove('show-error');
		}

		return {
			hasError,
			value: genderValue,
			text: genderText,
		};
	}

	function calcFunction(data, { regionText, ageText, genderText }) {
		const premiumData = Math.round(data.premium),
			annChangeData = Math.round(data.annchange),
			posOrNegText = Math.sign(annChangeData) >= 0 ? 'an increase' : 'a decrease',
			lastYear = Math.round(premiumData / (1 + annChangeData / 100));

		// Heading
		calcHeading.textContent = 'The average car insurance based on what you entered is';

		// Premium
		premiumEl.textContent = '';
		const priceSpan = document.createElement('span');
		priceSpan.className = 'price';
		priceSpan.textContent = `£${premiumData}`;

		const perYearSpan = document.createElement('span');
		perYearSpan.className = 'peryear';
		perYearSpan.textContent = ' per year';
		premiumEl.append(priceSpan, perYearSpan);

		// Results Text
		resultsText.textContent = '';
		const blockSpan = document.createElement('span');
		blockSpan.className = 'block';

		const boldSpan1 = document.createElement('span');
		boldSpan1.className = 'bold';
		boldSpan1.textContent = `${genderText}, ${ageText}`;

		const regionSpan = document.createElement('span');
		regionSpan.className = 'bold';
		regionSpan.textContent = `${regionText}`;
		blockSpan.append(boldSpan1, document.createTextNode(' in '), regionSpan);
		resultsText.append(document.createTextNode('Based on the average insurance premium for: '), blockSpan);

		// Annual Change
		annChangeEl.textContent = '';
		const boldChange = document.createElement('span');
		boldChange.className = 'bold';
		boldChange.textContent = `${posOrNegText} of ${Math.abs(annChangeData)}%`;

		const boldLastYear = document.createElement('span');
		boldLastYear.className = 'bold';
		boldLastYear.textContent = `£${lastYear}`;
		annChangeEl.append(
			document.createTextNode('This is '),
			boldChange,
			document.createTextNode(" compared with last year's price of "),
			boldLastYear
		);
	}

	function showResults() {
		// Show results and hide form
		priceIndexForm.classList.add('display-none');
		priceIndexResults.classList.remove('display-none');
		resetBtn.classList.remove('display-none');
	}

	continueBtn?.addEventListener('click', e => {
		e.preventDefault();

		const regionResult = validateRegion(errorRegion);
		const ageResult = validateAge(errorAge);
		const genderResult = validateGender(errorGender);

		if (regionResult.hasError || ageResult.hasError || genderResult.hasError) {
			return;
		}

		sBannerStep(2);

		// Pull JSON
		const data = jsonData?.region?.[regionResult.value]?.[genderResult.value]?.[ageResult.value];
		if (!data) {
			console.error('No data for selection:', regionResult.value, genderResult.value, ageResult.value);
			return;
		}

		// Run calculation with values & text
		calcFunction(data, {
			regionText: regionResult.text,
			ageText: ageResult.text,
			genderText: genderResult.text,
		});

		showResults();
	});

	// Reset button
	resetBtn?.addEventListener('click', () => {
		const selects = priceIndexForm.querySelectorAll('select');
		selects.forEach(select => (select.selectedIndex = 0));

		const checkedRadio = document.querySelector('input[type=radio]:checked');
		if (checkedRadio) checkedRadio.checked = false;

		calcHeading.textContent = 'Enter your details to get the average car insurance price for your area';
		priceIndexResults.classList.add('display-none');
		priceIndexForm.classList.remove('display-none');

		sBannerStep(1);
	});

	async function init() {
		try {
			const el = dataCMSContainer;

			// 1. Try to load JSON from URL in data-json-path
			if (el.hasAttribute('data-json-path')) {
				const jsonPath = el.getAttribute('data-json-path');
				try {
					const response = await fetch(jsonPath);

					if (response.ok) {
						try {
							jsonData = await response.json();
						} catch (parseErr) {
							console.error('Failed to parse JSON from response:', parseErr);
						}
					} else {
						console.warn(`HTTP error ${response.status}, falling back to inline JSON`);
					}
				} catch (fetchErr) {
					console.warn(`Fetch failed: ${fetchErr.message}, falling back to inline JSON`);
				}
			}

			// 2. Fallback to inline JSON if no data loaded yet
			if (!jsonData && el.hasAttribute('data-json')) {
				const rawJson = el.getAttribute('data-json');

				if (rawJson && rawJson.trim() !== '') {
					try {
						jsonData = JSON.parse(rawJson);
					} catch {
						throw new Error('Invalid JSON in data-json attribute');
					}
				}
			}

			// 3. If still no JSON, warn
			if (!jsonData) {
				console.warn('No JSON data could be loaded from data-json-path or data-json.');
			}
		} catch (err) {
			console.error('Failed to load JSON:', err.message);
		}

		// Initialise banner + populate dropdowns
		sBanner(
			widget,
			[bannerStep1Text, bannerStep2Text],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);

		populateDropdowns();
	}

	return {
		init,
	};
})();

// Run when DOM ready
document.addEventListener('DOMContentLoaded', () => {
	priceIndexCalc.init();
});
